import { HttpHandlerFn, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';
import { FILE_UPLOAD_TIMEOUT_MS } from '../constants/file-upload.constant';

/**
 * Interceptor that applies a 5-minute timeout to all requests with FormData body.
 * Covers 65 MB file uploads (registration, company create/edit, PDF upload, etc.).
 */
export const FileUploadTimeoutInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  if (!(req.body instanceof FormData)) {
    return next(req);
  }

  return next(req).pipe(
    timeout(FILE_UPLOAD_TIMEOUT_MS),
    catchError((error) => {
      if (error?.name === 'TimeoutError') {
        return throwError(
          () =>
            new HttpErrorResponse({
              error: { message: 'Request timed out. Please try again.' },
              status: 408,
            })
        );
      }
      return throwError(() => error);
    })
  );
};
